import { SupersimCampaignsType } from "./supersim.types";

export const SUPERSIM_EXPERIENCE_SESSION_KEY = 'supersim_experience';

export const SUPERSIM_UTM_MEDIUM = 'supersim';
export const SUPERSIM_UTM_SOURCE= 'supersim';
export const SUPERSIM_UTM_PRODUCT = 'score';

export const SUPERSIM_CAMPAIGN_SCORE: SupersimCampaignsType = 'score';
export const SUPERSIM_CAMPAIGN_DEBT: SupersimCampaignsType = 'debt';
export const SUPERSIM_CAMPAIGN_CANCEL_ACCOUNT: SupersimCampaignsType = 'cancel_account';

